/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API17320Req {
  
  /** 用户手机号 */
  userPhone?: string;
  /** 新密码 */
  newPasswd?: string;
};



export type API17320Res = {};


// 17320 修改密码

export interface IUsePostAPI17320Return {
  /** 修改密码: 接口请求状态 */
  isAPI17320Loading: boolean;
  /** 修改密码: 接口请求返回数据 */
  dataAPI17320: API17320Res;
  /**  修改密码: 接口数据请求方法 */
  fetchAPI17320Data:  (inputs: API17320Req, config?: YWRequestConfig) => Promise<API17320Res>;
  /** 修改密码: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI17320 = ():IUsePostAPI17320Return => {
  let isMount = true;
  const [isAPI17320Loading, setIsAPI17320Loading] = useState(false);
  const [dataAPI17320, setDataAPI17320] = useState<API17320Res>({} as API17320Res);
  const requestUrl = `${basePath}/ywwl-admin/user/updatePassWd`;

  const fetchAPI17320Data = async (inputs: API17320Req, config?: YWRequestConfig): Promise<API17320Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API17320Req>) || {}) as API17320Req;
    
  
    if ( isMount ) {
      setIsAPI17320Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API17320Res>(`${basePath}/ywwl-admin/user/updatePassWd`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI17320(res || {} as API17320Res);
        setIsAPI17320Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI17320Loading(false);
      }
      return false as unknown as API17320Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI17320Loading,
    dataAPI17320,
    fetchAPI17320Data,
    requestUrl,
  }
}

